import { render } from "./RecordBookTabs.vue?vue&type=template&id=da8e475c&lang=pug"
import script from "./RecordBookTabs.vue?vue&type=script&lang=js"
export * from "./RecordBookTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__